import { render, staticRenderFns } from "./CardsPageFilters.vue?vue&type=template&id=158e9976"
import script from "./CardsPageFilters.vue?vue&type=script&lang=js"
export * from "./CardsPageFilters.vue?vue&type=script&lang=js"
import style0 from "./CardsPageFilters.vue?vue&type=style&index=0&id=158e9976&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports